(function () {
    'use strict';

    run.admin.parts.rackootAiTileSuggestions = function() {
        const btn_new = document.getElementById('btn_new_menu');

        const rackoot_data = document.getElementById('rackoot_data');

        if (btn_new !== null && btn_new !== 'undefined') {
            let loading_template = document.getElementById('template_loading_suggestions');
            if (loading_template != null) {
                btn_new.insertAdjacentHTML('beforeBegin', loading_template.innerHTML);
                loadAiSuggestions(2);
            }
        }
    };
})();
